// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-671ed61a]{color:#fff;padding:.3125rem;background:#2a8de9;margin:0 .260417rem}", ""]);
// Exports
module.exports = exports;
